import { buildInitialExportName } from '@/features/DataHub/modules/Export/services/ExportNameService';

const DEFAULT_EXPORT_BASE_NAME = 'GX-Chart';

export const buildCustomChartInitialExportName = (baseName: string): string => {
  return buildInitialExportName(baseName, DEFAULT_EXPORT_BASE_NAME);
};

export const buildCustomChartExportFileName = (exportName: string): string =>
  buildCustomChartInitialExportName(exportName);
